import 'css-chunksrc/client/scenes/projectStrategicAxes/projectStrategicAxesTable/projectStrategicAxisCreation/scoreTag/styles.scss';export default {
  "tag": "_tag_1vuxs_1",
  "positiveTag": "_positiveTag_1vuxs_7",
  "negativeTag": "_negativeTag_1vuxs_11"
};